import {Grid, GridProps} from '@mui/material'

export const MaterialsGrid = ({children, ...props}: GridProps & {children: React.ReactNode}) => (
  <Grid {...props} container columns={5} rowSpacing={3} columnSpacing={1}>
    {children}
  </Grid>
)
